import {
  accountTransactionSimulationRequestSchema,
  type AccountTransactionDraft,
  type TransactionSimulationResponse,
} from '@mls-wallet/shared-types';
import denApi from './denApi';

export function simulateTransaction(
  request: AccountTransactionDraft,
  signal?: AbortSignal
): Promise<TransactionSimulationResponse> {
  // Validate execution fields without replacing the full draft with a reduced payload.
  accountTransactionSimulationRequestSchema.parse(request);
  return denApi.post<TransactionSimulationResponse, AccountTransactionDraft>(
    'transaction-builder/simulate',
    request,
    signal ? { signal } : undefined
  );
}

export function simulateStoredTransaction(
  transactionId: string,
  signal?: AbortSignal
): Promise<TransactionSimulationResponse> {
  return denApi.post<TransactionSimulationResponse, undefined>(
    `transactions/${encodeURIComponent(transactionId)}/simulate`,
    undefined,
    signal ? { signal } : undefined
  );
}
